

























import { Component, PropSync, Vue } from 'vue-property-decorator';
import { validateURL } from '@/utils/validate';

const namespace: string = 'inventory';

@Component
export default class TabVendor extends Vue {
  @PropSync('vendorInfo', { type: String }) syncedVendorInfo!: string;
  @PropSync('vendorUrl', { type: String }) syncedVendorUrl!: string;
  @PropSync('contactName', { type: String }) syncedContactName!: string;
  @PropSync('contactPhone', { type: String }) syncedContactPhone!: string;
  @PropSync('contactEmail', { type: String }) syncedContactEmail!: string;

  public validateURL: Function = validateURL;
}
